<template>
  <v-card class="pt-5 px-5" style="border-radius: 0px" flat>
    <v-data-table
      class="elevation-2"
      fixed-header
      :headers="headers_materie_prime"
      height="70vh"
      :items="
        filtro_picking_completa === true
          ? items_materie_prime
          : items_materie_prime.filter((e) => e.residuo > 0)
      "
    >
      <!-- Titolo della tabella -->
      <template v-slot:top>
        <v-toolbar color="indigo" dense style="border-radius: 0px">
          <v-toolbar-title class="white--text"> Picking </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="switchFiltroPickingCompleta"
                :color="filtro_picking_completa === true ? '' : 'purple'"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  :color="filtro_picking_completa === true ? 'purple' : 'white'"
                >
                  mdi-list-status
                </v-icon>
              </v-btn>
            </template>
            <span>Filtro Picking Completi</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di indietro -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="clickIndietro" small v-on="on" v-bind="attrs">
                <v-icon color="error">mdi-keyboard-backspace</v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
      </template>

      <!-- Bottone di dettaglio -->
      <template v-slot:[`item.dettaglio`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="clickDettaglioMateria(item)"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary"> mdi-human-dolly </v-icon>
            </v-btn>
          </template>
          <span>Esegui Picking</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Dialog del dettaglio della materia prima -->
    <v-dialog v-model="dialog_dettaglio_materia">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Dettaglio Materia Prima
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone dell'impegno -->
          <v-btn
            @click="
              setCommessaImpegno({
                id_commessa: riga_sel.id_commessa,
                id_commessa_dettaglio: riga_sel.id_commessa_dettaglio,
                id_articolo: riga_sel.id_articolo,
                id_componente: dati_impegno.id_articolo,
                cod_lotto: dati_impegno.cod_lotto,
                quantita:
                  dati_impegno.disponibilita > riga_sel.residuo
                    ? riga_sel.residuo
                    : dati_impegno.disponibilita,
              })
            "
            color="success"
            v-if="
              dati_impegno.disponibilita != null &&
              dati_impegno.disponibilita !== '' &&
              dati_impegno.disponibilita > 0
            "
          >
            CONFERMA
          </v-btn>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDettaglioMateria"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-container fluid>
            <v-row align="center" justify="center">
              <!-- Colonna di blocco del residuo = 0 -->
              <v-col
                class="mt-5"
                cols="6"
                v-if="riga_sel.residuo == 0 && riga_sel.residuo !== ''"
              >
                <v-card flat outlined :style="{ borderColor: 'orange' }">
                  <v-card-text
                    :style="{
                      color: 'orange',
                      fontSize: font_prompt_impegno + 'px',
                    }"
                  >
                    Il materiale per questa commessa risulta già completamente
                    prelevato.
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- Colonna del prompt a usare il QR code -->
              <v-col
                cols="6"
                v-else-if="
                  dati_impegno.disponibilita == null ||
                  dati_impegno.disponibilita === '' ||
                  riga_sel.residuo == null ||
                  riga_sel.residuo === ''
                "
              >
                <v-card flat outlined>
                  <v-card-text
                    :style="{ fontSize: font_prompt_impegno + 'px' }"
                  >
                    Qui saranno riportati i dati di impegno alla scansione di un
                    codice QR.
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- Colonna dei dati letti -->
              <v-col cols="6" v-else>
                <!-- Riga del codice articolo -->
                <v-row align="center">
                  <v-col
                    align="start"
                    cols="12"
                    :style="{ fontSize: font_prompt_impegno + 'px' }"
                  >
                    <b>Cod. Articolo:</b>
                    <span class="ml-5">
                      {{
                        dati_impegno.cod_articolo == null ||
                        dati_impegno.cod_articolo === ""
                          ? "N/D"
                          : dati_impegno.cod_articolo
                      }}</span
                    >
                  </v-col>
                </v-row>

                <!-- Riga della descrizione articolo -->
                <v-row align="center">
                  <v-col
                    align="start"
                    cols="12"
                    :style="{ fontSize: font_prompt_impegno + 'px' }"
                  >
                    <b>Des. Articolo:</b>
                    <span class="ml-5">
                      {{
                        dati_impegno.des_articolo == null ||
                        dati_impegno.des_articolo === ""
                          ? "N/D"
                          : dati_impegno.des_articolo
                      }}</span
                    >
                  </v-col>
                </v-row>

                <!-- Riga del codice lotto -->
                <v-row align="center">
                  <v-col
                    align="start"
                    cols="12"
                    :style="{ fontSize: font_prompt_impegno + 'px' }"
                  >
                    <b>Cod. Lotto:</b>
                    <span class="ml-5">
                      {{
                        dati_impegno.cod_lotto == null ||
                        dati_impegno.cod_lotto === ""
                          ? "N/D"
                          : dati_impegno.cod_lotto
                      }}
                    </span>
                  </v-col>
                </v-row>

                <!-- Riga della quantità lotto -->
                <v-row align="center">
                  <v-col
                    align="start"
                    cols="12"
                    :style="{ fontSize: font_prompt_impegno + 'px' }"
                  >
                    <b>Q.tà Lotto:</b>
                    <span class="ml-5">
                      {{
                        dati_impegno.quantita == null ||
                        dati_impegno.quantita === ""
                          ? "N/D"
                          : dati_impegno.quantita
                      }}</span
                    >
                  </v-col>
                </v-row>

                <!-- Riga della giacenza -->
                <v-row align="center">
                  <v-col
                    align="start"
                    cols="12"
                    :style="{ fontSize: font_prompt_impegno + 'px' }"
                  >
                    <b>Giacenza a magazzino:</b>
                    <span class="ml-5">
                      {{
                        dati_impegno.giacenza == null ||
                        dati_impegno.giacenza === ""
                          ? "N/D"
                          : dati_impegno.giacenza
                      }}</span
                    >
                  </v-col>
                </v-row>

                <!-- Riga della quantità disponibile -->
                <v-row align="center">
                  <v-col
                    align="start"
                    cols="12"
                    :style="{ fontSize: font_prompt_impegno + 'px' }"
                  >
                    <b>Disponibilità a magazzino:</b>
                    <span class="ml-5">
                      {{
                        dati_impegno.disponibilita == null ||
                        dati_impegno.disponibilita === ""
                          ? "N/D"
                          : dati_impegno.disponibilita
                      }}</span
                    >
                  </v-col>
                </v-row>

                <!-- Riga del fabbisogno -->
                <v-row align="center">
                  <v-col
                    align="start"
                    cols="12"
                    :style="{ fontSize: font_prompt_impegno + 'px' }"
                  >
                    <b>Fabbisogno:</b>
                    <span class="ml-5">
                      {{
                        dati_impegno.fabbisogno == null ||
                        dati_impegno.fabbisogno === ""
                          ? "N/D"
                          : dati_impegno.fabbisogno
                      }}</span
                    >
                  </v-col>
                </v-row>

                <!-- Riga del residuo -->
                <v-row align="center">
                  <v-col
                    align="start"
                    cols="12"
                    :style="{ fontSize: font_prompt_impegno + 'px' }"
                  >
                    <b>Residuo:</b>
                    <span class="ml-5">
                      {{
                        riga_sel.residuo == null || riga_sel.residuo === ""
                          ? "N/D"
                          : riga_sel.residuo
                      }}</span
                    >
                  </v-col>
                </v-row>

                <!-- Prompt dell'impegno -->
                <v-row
                  align="center"
                  class="mt-5"
                  justify="center"
                  v-if="
                    dati_impegno.disponibilita != null &&
                    dati_impegno.disponibilita !== '' &&
                    dati_impegno.disponibilita > 0
                  "
                >
                  <v-col
                    cols="12"
                    :style="{ fontSize: font_prompt_impegno + 'px' }"
                  >
                    La quantità del prelievo sarà di
                    <b>{{
                      dati_impegno.disponibilita > riga_sel.residuo
                        ? riga_sel.residuo
                        : dati_impegno.disponibilita
                    }}</b>
                    unità: procedere?
                  </v-col>
                </v-row>

                <!-- Avviso di assenza di disponibilità -->
                <v-row align="center" class="mt-5" justify="center" v-else>
                  <v-col
                    cols="12"
                    :style="{ fontSize: font_prompt_impegno + 'px' }"
                  >
                    <b>
                      <span :style="{ color: 'orange' }">
                        Attenzione: disponibilità insufficiente!
                      </span>
                    </b>
                  </v-col>
                </v-row>
              </v-col>

              <!-- Colonna del lettore multiplo -->
              <v-col
                cols="6"
                v-if="riga_sel.residuo !== '' && riga_sel.residuo > 0"
              >
                <MultiDataMatrixReader
                  ref="qr"
                  @clickChiudi="qr_attivo = false"
                  v-on:detectQrCode="detectQrCode"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <!-- Overlay di caricamento -->
      <v-overlay :value="overlay_dettaglio" style="z-index: 10">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import MultiDataMatrixReader from "@/components/TOOLS/MultiDataMatrixReader.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Impegno {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte i campi
  reset() {
    const campi = this.setControlli();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setControlli() {
    const campi = [
      { nome: "cod_articolo", default_val: "" },
      { nome: "cod_lotto", default_val: "" },
      { nome: "des_articolo", default_val: "" },
      { nome: "disponibilita", default_val: null },
      { nome: "fabbisogno", default_val: null },
      { nome: "giacenza", default_val: null },
      { nome: "id_articolo", default_val: null },
      { nome: "quantita", default_val: null },
    ];
    return campi;
  }
}

export default {
  name: "",
  components: {
    MultiDataMatrixReader,
    SnackbarQV,
  },
  props: {
    rotta_back: {
      type: String,
      default: "/home/production",
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      dati_impegno: new Impegno(),
      filtro_picking_completa: false,
      font_prompt_impegno: 20,
      qr_code_sel: new Object(),
      riga_sel: new Object(),

      // Modal
      dialog_dettaglio_materia: false,
      overlay: false,
      overlay_dettaglio: false,

      // Array
      headers_materie_prime: [
        { text: "Dettaglio", value: "dettaglio", sortable: false },
        { text: "Des Magazzino", value: "des_magazzino", sortable: false },
        { text: "Cod. Commessa", value: "cod_commessa", sortable: false },
        { text: "Cod. Articolo", value: "cod_articolo", sortable: false },
        { text: "Cod. Componente", value: "cod_componente", sortable: false },
        { text: "Cod. Lotto", value: "cod_lotto", sortable: false },
        { text: "Giacenza", value: "giacenza", sortable: false },
        { text: "Fabbisogno", value: "fabbisogno", sortable: false },
        { text: "Residuo", value: "residuo", sortable: false },
      ],
      items_materie_prime: new Array(),
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    clickIndietro() {
      this.$router.push(this.rotta_back);
    },
    chiudiDettaglioMateria() {
      this.dialog_dettaglio_materia = false;

      // Disconnetto la telecamera, nel caso fose attiva.
      this.$refs.qr.chiudiModalQR();

      // Resetto le variabili di supporto.
      this.riga_sel = new Object();
      this.dati_impegno = new Impegno();
    },
    clickDettaglioMateria(arg) {
      this.riga_sel = Object.assign({}, arg);
      this.dialog_dettaglio_materia = true;
    },
    detectQrCode(arg) {
      // Controllo l'intestazione del QR Code.
      if (!arg.includes("GETQRC")) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme, impossibile acquisire i dati."
        );
        return;
      }

      // Controllo il codice articolo.
      if (!arg.includes("(P)")) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non contiene l'indice (P): nessun Codice Articolo, impossibile acquisire i dati."
        );
        return;
      }

      // Controllo il Lotto assegnato internamente dalla mia ditta.
      if (!arg.includes("(L)")) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non contiene l'indice (L): nessun Lotto Interno, impossibile acquisire i dati."
        );
        return;
      }

      // Controllo il Lotto originale assegnato dal fornitore.
      if (!arg.includes("(H)")) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non contiene l'indice (H): nessun Lotto Fornitore, impossibile acquisire i dati."
        );
        return;
      }

      // Controllo che il codice contenga l'informazione di quantità.
      if (!arg.includes("(Q)")) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non contiene l'indice (Q): nessuna Quantità, impossibile acquisire i dati."
        );
        return;
      }

      /* Mando i dati del codice QR al BE che fa
       * dei controlli sulle quantità impegnabili. */
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "checkmagazzinoqr",
          token: localStorage.user_token,
          qrcode: arg,
        },
      };

      this.overlay_dettaglio = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay_dettaglio = false;
          if (res.status === 200) {
            this.dati_impegno = new Impegno(res.data.result.dati[0]);
            console.log(res.data.result.dati[0]);
            console.log(this.dati_impegno.disponibilita);
            this.dati_impegno.fabbisogno = this.riga_sel.fabbisogno;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile ottenere i dati."
            );
          }
        })
        .catch(() => {
          this.overlay_dettaglio = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile ottenere i dati."
          );
        });
    },
    getMateriePrime() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getpickingcommessa",
          token: localStorage.user_token,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.items_materie_prime = res.data.result.materieprime;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    setCommessaImpegno(arg) {
      /* Il metodo prende in argomento un oggetto, che arriva impostato
       * dalla template per contenere nei suoi parametri valori tali da
       * consentire agevolmente la composizione di una request. Di seguito
       * faccio dei controlli per essere sicuro che il dato sia valido.
       * (Questi controlli non dovrebbero mai scattare perché la template
       * fa già dei controlli di suo, ma non si sa mai). */

      /* Controllo che la riga selezionata abbia
       * ancora necessità di prelevare materia prima. */
      if (this.riga_sel.residuo == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Questo componente risulta già impegnato in quantità sufficiente a soddisfare la commessa.`
        );
        return;
      }

      // Controllo che la materia prima sia disponibile.
      if (this.dati_impegno.disponibilita == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          `La disponibilità di questo lotto è insufficiente.`
        );
        return;
      }

      /* Controllo che l'utente non stia impegnando
       * un articolo diverso da quello che gli serve. */
      if (arg.id_componente != this.riga_sel.id_componente) {
        this.$refs.SnackbarQV.print(
          "orange",
          `L'articolo identificato dal codice QR scansionato non corrisponde al componente selezionato per la commessa ${this.riga_sel.cod_commessa}.`
        );
        /* console.warn(
          `No match found between id_componente fields from function argument and selected row (${arg.id_componente}, ${this.riga_sel.id_componente}).`
        );*/
        return;
      }

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessaimpegno",
          token: localStorage.getItem("user_token"),
          id_commessa: arg.id_commessa,
          id_commessa_dettaglio: arg.id_commessa_dettaglio,
          id_articolo: arg.id_articolo,
          id_componente: arg.id_componente,
          cod_lotto: arg.cod_lotto,
          quantita: arg.quantita,
        },
      };

      this.overlay_dettaglio = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay_dettaglio = false;
          if (res.status === 200) {
            // Chiudo la finestra di dialogo.
            this.dialog_dettaglio_materia = false;

            // Resetto le variabili di supporto.
            this.riga_sel = new Object();
            this.dati_impegno = new Impegno();

            // Disconnetto la telecamera, nel caso fose attiva.
            this.$refs.qr.chiudiModalQR();

            this.getMateriePrime();
            this.$refs.SnackbarQV.print(
              "success",
              "Impegno registrato con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay_dettaglio = false;
          console.error(e);

          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    switchFiltroPickingCompleta() {
      this.filtro_picking_completa = !this.filtro_picking_completa;
    },
  },
  created() {},
  mounted() {
    this.getMateriePrime();
  },
};
</script>
<style scoped>
</style>